import { render, staticRenderFns } from "./organization-policy.vue?vue&type=template&id=2f96741f"
import script from "./organization-policy.vue?vue&type=script&lang=js"
export * from "./organization-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports